import { useContext, useEffect, useState } from "react";
import Auxilliary from "./components/Auxilliary";
import Game from "./components/Game";
import Header from "./components/Header";
import Help from "./components/Help";
import Info from "./components/Info";
import Settings from "./components/Settings";
import Statistics from "./components/Statistics";
import Surprise from "./components/Surprise";
import { ThemeContext } from "./context/ThemeContext";
import Fade from "./transitions/Fade";

function App() {
  // State
  const [screen, setScreen] = useState("Help");
  const [reSpin, setReSpin] = useState(false);
  const [showStats, setShowStats] = useState(false);

  // Context
  const themeContext = useContext(ThemeContext);

  // Re-render globe
  useEffect(() => {
    if (screen === "Game") setReSpin(true);
  }, [screen]);
  useEffect(() => {
    if (reSpin) setTimeout(() => setReSpin(false), 1);
  }, [reSpin]);

  const pickScreen = () => {
    if (screen === "Help") {
      return (
        <Auxilliary screen={screen} setScreen={setScreen}>
          <Help />
        </Auxilliary>
      );
    } else if (screen === "Info") {
      return (
        <Auxilliary screen={screen} setScreen={setScreen}>
          <Info setScreen={setScreen} />
        </Auxilliary>
      );
    } else if (screen === "Settings") {
      return (
        <Auxilliary screen={screen} setScreen={setScreen}>
          <Settings />
        </Auxilliary>
      );
    } else if (screen === "Surprise") {
      return <Surprise />;
    } else {
      return <Game reSpin={reSpin} setShowStats={setShowStats} />;
    }
  };

  const dark = themeContext.theme.nightMode ? "dark" : "";

  return (
    <div
      className={`max-w-xs sm:max-w-md md:max-w-2xl mx-auto 
      z-10 absolute top-0 bottom-0 left-0 right-0 block ${dark}`}
    >
      <Header
        setScreen={setScreen}
        setReSpin={setReSpin}
        setShowStats={setShowStats}
      />
      <Fade
        show={showStats}
        background="text-gray-900 dark:text-gray-300 dark:bg-slate-900 
      border-2 border-sky-700 dark:border-slate-700 drop-shadow-xl 
      absolute z-10 top-24 sm:max-w-sm inset-x-0 mx-auto py-2 px-6 rounded-md space-y-2"
      >
        <Statistics setShowStats={setShowStats} setScreen={setScreen} />
      </Fade>
      {pickScreen()}
    </div>
  );
}

export default App;
